@if (!editMode) {
  <ngx-duration-picker
    [(value)]="data"
    [options]="fieldConfig.durationOptions"
    [disabled]="true"
    class="view-mode-duration"></ngx-duration-picker>
}
@if (formGroup) {
  <form [formGroup]="formGroup">
    @if (editMode) {
      <ngx-duration-picker
        formControlName="{{ fieldConfig.name }}"
        [options]="fieldConfig.durationOptions"></ngx-duration-picker>
    }
  </form>
}
